{
  "R": [0, 255, 255],
  "G": [0,   0, 255],
  "B": [0,   0,   0],
  "A": [0,  64,  64],
  "I": [0,  86, 255]
}
